module.exports = __webpack_public_path__ + "static/media/logo.07b94ae8.png";